import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { useAccount } from '@/apps/adok/entities/account'

export type MalwareTabName = 'scans' | 'tasks' | 'blockers'

const TABS: {
  label: string
  name: MalwareTabName
  route: string
  staffOnly?: boolean
}[] = [
  {
    label: 'Scans (Admin Only)',
    name: 'scans',
    route: 'malware-scans',
    staffOnly: true
  },
  { label: 'Alerts', name: 'tasks', route: 'malware-tasks' },
  { label: 'Creatives quarantine', name: 'blockers', route: 'malware-blockers' }
]

export function useMalwareTabs() {
  const router = useRouter()
  const { isStaff } = useAccount()

  const tabs = computed(() =>
    TABS.filter((tab) => !tab.staffOnly || isStaff.value)
  )

  function open(name: string) {
    const tab = TABS.find((item) => item.name === name)

    if (tab) router.push({ name: tab.route })
  }

  return { tabs, open }
}
